import { Document, Page, pdfjs } from "react-pdf";
import { useState } from "react";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import Modal from "./Modal";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
// Obligatoire : configuration du worker

export default function MyPDFViewer({ base64, isOpen, onClose }) {
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Prépare l'URL data: pour react-pdf
  const pdfDataUrl = `data:application/pdf;base64,${base64}`;

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Document
          file={pdfDataUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading="Chargement du PDF..."
        >
          {Array.from(new Array(numPages), (_, index) => (
            <Page key={index} pageNumber={index + 1} />
          ))}
        </Document>
      </Modal>
    </div>
  );
}
